"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSignalRConnectionStatus = void 0;
var react_1 = require("react");
var types_1 = require("../types");
var SignalRContext_1 = require("./SignalRContext");
var useSignalRConnectionStatus = function (_a) {
    var onConnect = _a.onConnect;
    var isMounted = (0, react_1.useRef)(false);
    var connectionStatus = (0, react_1.useContext)(SignalRContext_1.SignalRContext).connectionStatus;
    (0, react_1.useEffect)(function () {
        //Dont fire on first render - only when the connection status changes while already on the screen
        if (!isMounted.current) {
            isMounted.current = true;
            return;
        }
        switch (connectionStatus) {
            case types_1.ConnectionStatus.Connected:
                if (onConnect)
                    onConnect();
                break;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [connectionStatus]);
};
exports.useSignalRConnectionStatus = useSignalRConnectionStatus;
